import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";
import { useAuth } from "../../contexts/AuthContext";
import { C, F, Label, Rule, Btn } from "../ui";

// Config de cada rubro a medida
const RUBROS_CONFIG = {
  carpinteria: {
    titulo: "Carpintería a medida",
    subtitulo: "Aluminio y PVC — Ventanas, puertas y paños según tus planos",
    icono: "▱",
    campos: [
      { id: "tipo",        label: "Tipo de carpintería", tipo: "select", opciones: ["Ventana corredera", "Ventana batiente", "Ventana oscilobatiente", "Puerta exterior", "Puerta interior", "Paño fijo", "Combinada"] },
      { id: "material",    label: "Material",            tipo: "select", opciones: ["Aluminio natural", "Aluminio lacado blanco", "Aluminio anodizado negro", "PVC blanco", "PVC gris antracita"] },
      { id: "vidrio",      label: "Tipo de vidrio",      tipo: "select", opciones: ["Simple 4mm", "DVH 4+9+4mm", "DVH 4+12+4mm", "DVH con film térmico", "Sin vidrio (solo marco)"] },
      { id: "apertura",    label: "Sistema de apertura", tipo: "select", opciones: ["Corredera", "Batiente hacia adentro", "Batiente hacia afuera", "Oscilobatiente", "Fijo sin apertura", "Pivotante"] },
      { id: "ancho",       label: "Ancho total (cm)",    tipo: "number", placeholder: "120" },
      { id: "alto",        label: "Alto total (cm)",     tipo: "number", placeholder: "120" },
      { id: "cantidad",    label: "Cantidad de unidades",tipo: "number", placeholder: "1" },
      { id: "terminacion", label: "Terminación",         tipo: "select", opciones: ["Estándar", "Premium con burletes reforzados", "Acústico especial"] },
    ]
  },
  cocinas: {
    titulo: "Cocinas integrales a medida",
    subtitulo: "Muebles bajos, altos y torres según el plano de tu cocina",
    icono: "⬡",
    campos: [
      { id: "tipo_mueble",    label: "Tipo de muebles",        tipo: "multicheck", opciones: ["Muebles bajos", "Muebles altos", "Torre despensero", "Isla central", "Bajo mesada con pileta"] },
      { id: "material_frente",label: "Material del frente",    tipo: "select", opciones: ["MDF lacado mate", "MDF lacado brillante", "MDF con vinilo texturado", "Madera enchapada roble", "Melamina blanco", "Melamina gris cemento"] },
      { id: "sistema_apertura",label: "Sistema de apertura",   tipo: "select", opciones: ["Bisagra estándar push", "Push to open (sin tirador)", "Amortiguado Blum", "Tirador barra aluminio"] },
      { id: "cajones",        label: "Cajones interiores",     tipo: "select", opciones: ["Sin cajones", "Cajones simples", "Cajones Tandem con guías Blum", "Cajones con organizadores"] },
      { id: "mesada",         label: "Mesada",                 tipo: "select", opciones: ["No incluye", "Porcelanato 2cm", "Cuarzo compacto", "Acero inoxidable", "Silestone"] },
      { id: "ancho_total",    label: "Ancho total del espacio (cm)", tipo: "number", placeholder: "300" },
      { id: "alto_muebles",   label: "Alto de muebles bajos (cm)",  tipo: "number", placeholder: "85" },
      { id: "cantidad_puertas",label: "Cantidad de puertas aprox.", tipo: "number", placeholder: "10" },
    ]
  },
  vanitorys: {
    titulo: "Vanitorys y muebles de baño a medida",
    subtitulo: "Muebles, espejos y nichos según las medidas de tu baño",
    icono: "▭",
    campos: [
      { id: "tipo",           label: "Tipo de mueble",         tipo: "select", opciones: ["Vanitory suspendido", "Vanitory con pie", "Doble pileta", "Mueble columna", "Nicho empotrado", "Espejo con luz LED"] },
      { id: "material",       label: "Material",               tipo: "select", opciones: ["MDF lacado blanco", "MDF lacado negro", "Madera enchapada roble", "MDF con vinilo cemento", "Melamina"] },
      { id: "pileta",         label: "Incluye pileta/bacha",   tipo: "select", opciones: ["No incluye", "Bacha sobre cubierta cerámica", "Bacha integrada", "Bacha vessel vidrio", "Doble bacha"] },
      { id: "ancho",          label: "Ancho (cm)",             tipo: "number", placeholder: "80" },
      { id: "alto",           label: "Alto (cm)",              tipo: "number", placeholder: "50" },
      { id: "profundidad",    label: "Profundidad (cm)",       tipo: "number", placeholder: "45" },
      { id: "cantidad",       label: "Cantidad",               tipo: "number", placeholder: "1" },
    ]
  }
};

function FormAMedida({ rubro, onEnviado }) {
  const { user, profile } = useAuth();
  const config = RUBROS_CONFIG[rubro];
  const [form, setForm] = useState({});
  const [notas, setNotas] = useState("");
  const [proyecto, setProyecto] = useState("");
  const [sending, setSending] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const set = (id, val) => setForm(p => ({ ...p, [id]: val }));

  const toggleMulti = (id, val) => {
    const current = form[id] || [];
    set(id, current.includes(val) ? current.filter(x => x !== val) : [...current, val]);
  };

  const enviar = async () => {
    setSending(true);
    await addDoc(collection(db, "items_medida"), {
      rubro,
      proyecto,
      especificaciones: form,
      notas,
      estado: "recibido",
      usuario_id: user?.uid,
      usuario_email: user?.email,
      usuario_nombre: profile?.nombre || "",
      creadoEn: serverTimestamp(),
    });
    setSending(false);
    setEnviado(true);
    onEnviado?.();
  };

  if (enviado) return (
    <div style={{ background: "#0A1A0A", border: `0.5px solid ${C.green}`, padding: 40, textAlign: "center" }}>
      <div style={{ fontFamily: F.serif, fontSize: 28, color: C.green, marginBottom: 8 }}>✓ Solicitud enviada</div>
      <div style={{ fontFamily: F.sans, fontSize: 13, color: C.muted, lineHeight: 1.7 }}>
        Recibimos tu solicitud de cotización para <strong style={{ color: C.off }}>{config.titulo}</strong>.<br/>
        En menos de 48 horas hábiles te contactamos con el presupuesto y los próximos pasos.
      </div>
    </div>
  );

  return (
    <div>
      {/* Proyecto */}
      <div style={{ marginBottom: 20 }}>
        <Label style={{ marginBottom: 6 }}>Nombre del proyecto / obra</Label>
        <input value={proyecto} onChange={e => setProyecto(e.target.value)}
          placeholder="Torre Palermo — Depto 4B"
          style={{ width: "100%", background: "transparent", border: "none", borderBottom: `0.5px solid ${C.border2}`, color: C.white, fontFamily: F.sans, fontSize: 13, padding: "7px 0", outline: "none" }}
        />
      </div>

      <Rule />

      {/* Campos específicos del rubro */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        {config.campos.map(campo => (
          <div key={campo.id} style={{ marginBottom: 4 }}>
            <Label style={{ marginBottom: 8 }}>{campo.label}</Label>

            {campo.tipo === "select" && (
              <select value={form[campo.id] || ""} onChange={e => set(campo.id, e.target.value)}
                style={{ width: "100%", background: C.s2, border: `0.5px solid ${C.border2}`, color: C.off, fontFamily: F.sans, fontSize: 12, padding: "8px 10px", outline: "none" }}>
                <option value="">Seleccioná...</option>
                {campo.opciones.map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            )}

            {campo.tipo === "number" && (
              <input type="number" value={form[campo.id] || ""} onChange={e => set(campo.id, e.target.value)}
                placeholder={campo.placeholder}
                style={{ width: "100%", background: "transparent", border: "none", borderBottom: `0.5px solid ${C.border2}`, color: C.white, fontFamily: F.mono, fontSize: 14, padding: "6px 0", outline: "none" }}
              />
            )}

            {campo.tipo === "multicheck" && (
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {campo.opciones.map(o => (
                  <label key={o} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                    <input type="checkbox"
                      checked={(form[campo.id] || []).includes(o)}
                      onChange={() => toggleMulti(campo.id, o)}
                    />
                    <span style={{ fontFamily: F.sans, fontSize: 11, color: C.off }}>{o}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <Rule />

      {/* Planos */}
      <div style={{ marginBottom: 20 }}>
        <Label style={{ marginBottom: 8 }}>Planos / croquis (opcional)</Label>
        <div style={{ border: `0.5px dashed ${C.border2}`, padding: "24px 20px", textAlign: "center" }}>
          <div style={{ fontFamily: F.sans, fontSize: 12, color: C.muted, marginBottom: 8 }}>
            Adjuntá planos en PDF, DWG o imagen (JPG/PNG)
          </div>
          <div style={{ fontFamily: F.mono, fontSize: 9, color: C.muted, marginBottom: 12 }}>
            Mientras implementamos la subida de archivos, podés enviarnos los planos por WhatsApp o email al confirmar la solicitud.
          </div>
          <div style={{ fontFamily: F.mono, fontSize: 9, color: C.off }}>
            📎 Subida de archivos — próximamente
          </div>
        </div>
      </div>

      {/* Notas */}
      <div style={{ marginBottom: 24 }}>
        <Label style={{ marginBottom: 6 }}>Notas adicionales</Label>
        <textarea value={notas} onChange={e => setNotas(e.target.value)}
          placeholder="Describí cualquier detalle especial, acabados particulares, restricciones de espacio, etc."
          rows={3}
          style={{ width: "100%", background: "transparent", border: `0.5px solid ${C.border2}`, color: C.white, fontFamily: F.sans, fontSize: 12, padding: 10, outline: "none", resize: "vertical" }}
        />
      </div>

      <Btn variant="solid" onClick={enviar} disabled={sending || !proyecto}
        style={{ width: "100%", justifyContent: "center" }}>
        {sending ? "Enviando..." : "Solicitar cotización →"}
      </Btn>

      <div style={{ fontFamily: F.mono, fontSize: 9, color: C.muted, textAlign: "center", marginTop: 10 }}>
        Respuesta en menos de 48 horas hábiles
      </div>
    </div>
  );
}

export default function CompradorAMedida() {
  const [rubroSeleccionado, setRubroSeleccionado] = useState(null);
  const [solicitudes, setSolicitudes] = useState([]);

  const rubros = Object.entries(RUBROS_CONFIG);

  if (rubroSeleccionado) {
    const config = RUBROS_CONFIG[rubroSeleccionado];
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
          <button onClick={() => setRubroSeleccionado(null)} style={{
            fontFamily: F.sans, fontSize: 9, letterSpacing: 1.5, textTransform: "uppercase",
            background: "transparent", border: "none", color: C.muted, cursor: "pointer",
          }}>← Volver</button>
          <div style={{ width: "0.5px", height: 14, background: C.border }} />
          <div style={{ fontFamily: F.mono, fontSize: 12, color: C.muted }}>{config.icono} {config.titulo}</div>
        </div>

        <div style={{ background: C.s1, border: `0.5px solid ${C.border}`, padding: 28 }}>
          <div style={{ fontFamily: F.serif, fontSize: 22, color: C.white, marginBottom: 6 }}>{config.titulo}</div>
          <div style={{ fontFamily: F.sans, fontSize: 12, color: C.muted, marginBottom: 28, lineHeight: 1.6 }}>{config.subtitulo}</div>
          <FormAMedida rubro={rubroSeleccionado} onEnviado={() => setTimeout(() => setRubroSeleccionado(null), 3000)} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <div style={{ fontFamily: F.serif, fontSize: 24, color: C.white, marginBottom: 6 }}>Productos a medida</div>
        <div style={{ fontFamily: F.sans, fontSize: 13, color: C.muted, lineHeight: 1.7, maxWidth: 560 }}>
          Para carpintería, cocinas y muebles de baño trabajamos directamente con las especificaciones de tu proyecto.
          Completá el formulario, el equipo en China cotiza con la fábrica y te respondemos en 48 horas.
        </div>
      </div>

      {/* Cards de rubros */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "0.5px", background: C.border, marginBottom: 32 }}>
        {rubros.map(([key, config]) => (
          <div key={key}
            onClick={() => setRubroSeleccionado(key)}
            style={{ background: C.s1, padding: "32px 28px", cursor: "pointer", transition: "background .2s" }}
            onMouseEnter={e => e.currentTarget.style.background = C.s2}
            onMouseLeave={e => e.currentTarget.style.background = C.s1}
          >
            <div style={{ fontFamily: F.mono, fontSize: 28, color: C.dim, marginBottom: 16 }}>{config.icono}</div>
            <div style={{ fontFamily: F.serif, fontSize: 20, color: C.white, marginBottom: 8, lineHeight: 1.2 }}>{config.titulo}</div>
            <div style={{ fontFamily: F.sans, fontSize: 11, color: C.muted, lineHeight: 1.6, marginBottom: 20 }}>{config.subtitulo}</div>
            <div style={{ fontFamily: F.sans, fontSize: 8, letterSpacing: 1.5, textTransform: "uppercase", color: C.amber, border: `0.5px solid ${C.amber}`, padding: "3px 10px", display: "inline-block", marginBottom: 16 }}>
              Cotización personalizada
            </div>
            <br/>
            <div style={{ fontFamily: F.sans, fontSize: 9, letterSpacing: 1.5, textTransform: "uppercase", color: C.off }}>
              Configurar y cotizar →
            </div>
          </div>
        ))}
      </div>

      {/* Cómo funciona a medida */}
      <div style={{ background: C.s1, border: `0.5px solid ${C.border}`, padding: 28 }}>
        <Label style={{ marginBottom: 20 }}>Cómo funciona el proceso a medida</Label>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: "0.5px", background: C.border }}>
          {[
            ["01", "Configurás", "Completás el formulario con las especificaciones y medidas de tu proyecto."],
            ["02", "Cotizamos", "Nuestro equipo en China consulta a la fábrica. Te respondemos en 48 horas."],
            ["03", "Aprobás el plano", "La fábrica emite el shop drawing. Vos aprobás antes de que empiecen a producir."],
            ["04", "Producción y entrega", "Con tu aprobación, entra al ciclo de contenedor y llega a tu depósito."],
          ].map(([n, t, d]) => (
            <div key={n} style={{ background: C.s1, padding: "24px 20px" }}>
              <div style={{ fontFamily: F.mono, fontSize: 9, color: C.muted, letterSpacing: 2, marginBottom: 16 }}>{n} —</div>
              <div style={{ fontFamily: F.serif, fontSize: 16, color: C.white, marginBottom: 10 }}>{t}</div>
              <div style={{ fontFamily: F.sans, fontSize: 11, color: C.muted, lineHeight: 1.7 }}>{d}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
